export const blockIconsTextformattingFormatListBulletedNew = (
	<span className='material-symbols-outlined'>format_list_bulleted</span>
);
